import axios from 'axios';

const viacepHttp = axios.create({
  baseURL: process.env.REACT_APP_API_ZIPCODE_URL,
});

export { viacepHttp };
